<div class="relative flex size-full min-h-0 flex-col overflow-x-hidden">
  <!-- Header -->
  <app-header></app-header>

  <!-- PWA install + notification dialog (shows on page load when applicable) -->
  <app-pwa-install-banner />

  <!-- Content wrapper: min-h-0 lets routed views shrink so footers/toolbars stay in viewport -->
  <div class="relative z-10 flex min-h-0 flex-1 flex-col">
    <div class="flex h-full min-h-0 flex-col">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>

  <!-- Push notification dialog (clinician joined video call, etc.) -->
  <app-push-notification-dialog />
</div>
